import React from 'react';
import './button.css'

export default ({ children, onClickHandler, id, style, classStyle, dataTip}) => {
    return (
        <div id={id} className={classStyle || 'button'} onClick={onClickHandler} style={style} data-tip={dataTip}>
            {children}
        </div>
        
    )
}